import axiosInstance from './Instance/axiosInstance';
import { Customer, CustomerInput } from '../types/customer';

export const getCustomers = async (): Promise<Customer[]> => {
    const response = await axiosInstance.get('/customers');
    return response.data;
};

export const createCustomer = async (data: CustomerInput): Promise<Customer> => {
    const response = await axiosInstance.post<Customer>('/customers', data);
    return response.data;
};

export const updateCustomerApi = async (id: string, data: CustomerInput): Promise<Customer> => {
    const response = await axiosInstance.put<Customer>(`/customers/${id}`, data);
    return response.data;
};
export const deleteCustomerApi = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/customers/${id}`);
};